import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import translations from '../translations';

const BlogEntry = ({ index, lang }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true); // Controla la visibilidad
  const titleKey = `entry${index}_title`;
  const descKey = `entry${index}_desc`;
  const images = {
    1: '/images/pancake1.png',
    2: '/images/anim.png',
    3: '/images/environment1.webp',
    4: '/images/ganzos1.png',
    5: '/images/claire1.png',
    6: '/images/bot1.png',
    7: '/images/landscape 2.png',
    8: '/images/render8.png',
    9: '/images/razevert.png',
    10: '/images/0000.png',
    11: '/images/Zelcar-Malogar.png',
    12: '/images/nada.jpg',
    13: '/images/nada.jpg',
    14: '/images/nada.jpg',
    15: '/images/nada.jpg',
    16: '/images/nada.jpg',
    17: '/images/nada.jpg',
    18: '/images/github1.webp',
  };

  const image = images[index] || '/images/nada.jpg';
  const title = translations[lang][titleKey] || `Entry ${index}`;
  const desc = translations[lang][descKey] || `Description ${index}`;

  const handleClick = (e) => {
    e.preventDefault();
    setIsVisible(false); // Inicia fade-out
    setTimeout(() => {
      navigate(`/entry/${index}`);
    }, 500); // Espera la duración de la transición (500ms)
  };

  useEffect(() => {
    setIsVisible(true); // Inicia fade-in al cargar
  }, []);

  return (
    <a
      href={`/entry/${index}`}
      onClick={handleClick}
      className={`blog-entry flex items-center gap-6 p-3 rounded-md hover:bg-white/5 hover:-translate-y-1 transition-all ${isVisible ? 'fade-in' : 'fade-out'}`}
    >
      <img
        src={image}
        alt={`Entrada del blog ${index}`}
        className="blog-image w-[150px] h-[150px] object-cover rounded-md hover:scale-103 transition-transform"
        onError={(e) => (e.target.src = `https://via.placeholder.com/150?text=Entrada+${index}`)}
      />
      <div className="blog-text flex-1">
        <h2 className="text-[#5A4C70] font-['Inter'] font-light text-[0.6em] tracking-[0.375em] mb-3 hover:underline">
          {title}
        </h2>
        <p className="text-[#A0A0A0] font-['Inter'] text-[0.75em] leading-[1.40625] font-light">
          {desc}
        </p>
      </div>
    </a>
  );
};

export default BlogEntry;
